"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;
var _react = _interopRequireDefault(require("react"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _excluded = ["children", "tag", "mt", "mb", "pt", "pb", "parentRef"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _CssClassNames = new _CssClassNames2["default"]({}, ['utility', 'text']),
  className = _CssClassNames.className,
  getCssProp = _CssClassNames.getCssProp;
var Heading = function Heading(_ref) {
  var children = _ref.children,
    tag = _ref.tag,
    mt = _ref.mt,
    mb = _ref.mb,
    pt = _ref.pt,
    pb = _ref.pb,
    parentRef = _ref.parentRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var Tag = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div'].includes(tag) ? tag : 'p';
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, parentRef && {
    ref: parentRef
  }, props, className("".concat(props.className ? props.className : '', " ").concat(tag === 'span' ? 'd-block' : '', " ").concat(getCssProp({
    mt: mt,
    mb: mb,
    pt: pt,
    pb: pb
  }, ['mt', 'mb', 'pt', 'pb']))), {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
};
exports.Heading = Heading;